import { render, staticRenderFns } from "./InfoAlt.vue?vue&type=template&id=066b1b16"
import script from "./InfoAlt.vue?vue&type=script&lang=js"
export * from "./InfoAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports